import { render, staticRenderFns } from "./feeDetailFeeRule.vue?vue&type=template&id=168aac0a"
import script from "./feeDetailFeeRule.vue?vue&type=script&lang=js"
export * from "./feeDetailFeeRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports